import { render, staticRenderFns } from "./PayWithPayPalAdvanced.vue?vue&type=template&id=44cf16da&scoped=true"
import script from "./PayWithPayPalAdvanced.vue?vue&type=script&lang=js"
export * from "./PayWithPayPalAdvanced.vue?vue&type=script&lang=js"
import style0 from "./PayWithPayPalAdvanced.vue?vue&type=style&index=0&id=44cf16da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cf16da",
  null
  
)

export default component.exports